import api from '../api'

export default api.resource({
  path    : 'lists',
  autosave : false,
  schema  : {
    data : [String]
  }
})
